import Vue from "vue";
import { GridPlugin, Page, Filter, Sort, Toolbar, Search, Edit, CommandColumn } from "@syncfusion/ej2-vue-grids";
import { CustomUrlAdaptor } from "@/syncfusion/CustomUrlAdaptor";
import { DataManager } from "@syncfusion/ej2-data";
import titleMixin from "@/mixins/title";
import gridMixin from "@/mixins/syncfusion/grid";
import SearchToolbar from "@/components/Templates/AttachmentTypes/SearchToolbar.vue";
Vue.use(GridPlugin);
export default Vue.extend({
    components: { "search-toolbar": SearchToolbar },
    mixins: [gridMixin, titleMixin],
    data() {
        return {
            title: this.$t("attachmentTypes.attachmentTypes"),
            data: new DataManager({
                url: process.env.VUE_APP_API_BASE_URL + "attachment-types/grid-data",
                //insertUrl: process.env.VUE_APP_API_BASE_URL + "attachment-types/grid-create",
                //updateUrl: process.env.VUE_APP_API_BASE_URL + "attachment-types/grid-edit",
                removeUrl: process.env.VUE_APP_API_BASE_URL + "attachment-types/grid-delete",
                adaptor: new CustomUrlAdaptor()
            }),
            filterOptions: { type: "Menu" },
            pageSettings: { pageSize: 10 },
            toolbarOptions: [
                {
                    text: this.$t("shared.add"),
                    tooltipText: this.$t("shared.add"),
                    prefixIcon: "e-add",
                    id: "Custom_Add"
                },
                "Search"
            ],
            sortOptions: {
                columns: [
                    { field: "OwnerTypeName", direction: "Ascending" },
                    { field: "Name", direction: "Ascending" }
                ]
            },
            searchOptions: {
                fields: ["Name"],
                operator: "contains"
            },
            editSettings: {
                allowEditing: false,
                allowAdding: false,
                allowDeleting: true,
                showDeleteConfirmDialog: true,
                mode: "Dialog"
            },
            commands: [
                {
                    type: "Custom_Edit",
                    title: this.$t("shared.edit"),
                    buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" }
                },
                {
                    type: "Delete",
                    buttonOption: { cssClass: "e-flat", iconCss: "e-delete e-icons" }
                }
            ]
        };
    },
    provide: {
        grid: [Page, Filter, Sort, Toolbar, Search, Edit, CommandColumn]
    },
    methods: {
        search(args) {
            const grid = this.$refs["attachment-types-grid"];
            const gridInstance = grid.ej2Instances;
            const filters = [];
            // Add grid filters
            for (const column of gridInstance.filterSettings.columns) {
                if (column.field != undefined && !["OwnerType"].includes(column.field))
                    filters.push(column);
            }
            // Add advanced filters
            if (args.ownerType != undefined)
                filters.push({ field: 'OwnerType', matchCase: false, operator: 'equal', predicate: 'and', value: args.ownerType });
            // Set filters and refresh grid
            gridInstance.filterSettings.columns = filters;
            grid.refresh();
        },
        toolbarClick(args) {
            if (args.item.id == "Custom_Add") {
                this.$router.push("/attachments/types/create");
                return;
            }
        },
        commandClick(args) {
            if (args.commandColumn.type === "Custom_Edit") {
                this.$router.push(`/attachments/types/${args.rowData.Id}/edit`);
                return;
            }
        },
        actionComplete(args) {
            if (args.requestType === "delete") {
                this.$toast.showSuccessToast(this.$t("attachmentTypes.delete.toastSuccessTitle"), this.$t("attachmentTypes.delete.toastSuccessContent", {
                    name: args.data[0].Name
                }));
            }
        }
    }
});
